import React from 'react'

const hexColor = val => /^#[0-9A-F]{6}$/i.test(val)

// An empty field means the widget keeps its own default.
function PixelField({ label, hint, placeholder, value, setValue }) {
  return (
    <div className="widget-form-field">
      <label>{label}</label>
      <input
        className="narrow-input"
        type="number"
        min="1"
        value={value}
        onChange={e => setValue(e.target.value)}
        placeholder={placeholder}
      />
      {hint && <span className="form-hint">{hint}</span>}
    </div>
  )
}

export default function TabStyling({ layout, setLayout, maxWidth, setMaxWidth, titleFontSize, setTitleFontSize, contentFontSize, setContentFontSize, textColor, setTextColor, accentColor, setAccentColor, backgroundColor, setBackgroundColor, t }) {
  return (
    <React.Fragment>
      <div className="widget-section-heading">{t('widget.sectionGeneral') || 'General'}</div>
      <div className="widget-form-field">
        <label>{t('widget.fieldLayout') || 'Layout'}</label>
        <select value={layout} onChange={e => setLayout(e.target.value)}>
          <option value="">{t('widget.layoutImageText') || 'Image + text'}</option>
          <option value="text-image">{t('widget.layoutTextImage') || 'Text + image'}</option>
        </select>
      </div>
      <PixelField
        label={t('widget.fieldMaxWidth') || 'Max width (px)'}
        hint={t('widget.fieldMaxWidthHint') || 'Leave empty to let the widget fill the space it is embedded in.'}
        placeholder="900"
        value={maxWidth}
        setValue={setMaxWidth}
      />
      <div className="widget-section-heading">{t('widget.sectionText') || 'Text'}</div>
      <PixelField
        label={t('widget.fieldTitleFontSize') || 'Title font size (px)'}
        hint={t('widget.fieldFontSizeHint') || 'Leave empty to use the default size.'}
        placeholder="16"
        value={titleFontSize}
        setValue={setTitleFontSize}
      />
      <PixelField
        label={t('widget.fieldContentFontSize') || 'Content font size (px)'}
        hint={t('widget.fieldFontSizeHint') || 'Leave empty to use the default size.'}
        placeholder="12"
        value={contentFontSize}
        setValue={setContentFontSize}
      />
      <div className="widget-section-heading">{t('widget.sectionColors') || 'Colors'}</div>
      <div className="widget-form-field">
        <label>{t('widget.fieldTextColor') || 'Text color'}</label>
        <div className="color-input-wrapper">
          <input type="text" value={textColor} onChange={e => setTextColor(e.target.value)} placeholder="#111111" />
          <div className="color-preview" style={{ backgroundColor: hexColor(textColor) ? textColor : 'transparent' }} title={textColor} />
        </div>
      </div>
      <div className="widget-form-field">
        <label>{t('widget.fieldAccentColor') || 'Accent color'}</label>
        <div className="color-input-wrapper">
          <input type="text" value={accentColor} onChange={e => setAccentColor(e.target.value)} placeholder="#000000" />
          <div className="color-preview" style={{ backgroundColor: hexColor(accentColor) ? accentColor : 'transparent' }} title={accentColor} />
        </div>
      </div>
      <div className="widget-form-field">
        <label>{t('widget.fieldBackgroundColor') || 'Background color'}</label>
        <div className="color-input-wrapper">
          <input type="text" value={backgroundColor} onChange={e => setBackgroundColor(e.target.value)} placeholder="#ffffff" />
          <div className="color-preview" style={{ backgroundColor: hexColor(backgroundColor) ? backgroundColor : 'transparent' }} title={backgroundColor} />
        </div>
      </div>
    </React.Fragment>
  )
}
